export type ConfigurationObjectParameterExtractorConfig = (
    key: string,
    dataset: { [key: string]: any },
    config?: { [key: string]: any },
) => any | undefined;

export type ConfigurationObjectExtractionConfig = {
    [key: string]: {
        extractor: ConfigurationObjectParameterExtractorConfig;
        config?: {
            [key: string]: any;
            default: any;
        };
    };
};

export function parseWidgetParameters<T extends object>(
    widget: HTMLElement,
    config: ConfigurationObjectExtractionConfig,
): T {
    return parseConfigurationObject<T>(widget.dataset, config);
}

export function parseConfigurationObject<T extends Object>(
    dataset: { [key: string]: any },
    config: ConfigurationObjectExtractionConfig,
): T {
    const output: T = {} as any;
    const setDefaultValueWhenPossible = (key: string, config: ConfigurationObjectExtractionConfig, output: any) => {
        const configEntry = config[key];
        if (configEntry?.config && 'default' in configEntry.config) {
            (output as any)[key] = configEntry.config.default;
        }

        return output;
    };

    for (const key of Object.keys(config)) {
        const configEntry = config[key];
        if (!configEntry) {
            continue;
        }

        const extractor = configEntry.extractor;

        // Skip keys with no extractor
        if (!extractor) {
            setDefaultValueWhenPossible(key, config, output);
            continue;
        }

        const extractedValue = extractor(key, dataset, configEntry.config);

        if (extractedValue !== undefined) {
            (output as any)[key] = extractedValue;
        }
    }

    return output;
}
